import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import { View } from 'foundations-components/components/View';
import DealCount from './DealCount';
import { StyledCurrencyWrapper } from '../../utils/StyledCurrencyWrapper';
import { RightAlignedTD } from '../styled/RightAlignedTD';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DealRollupCell = ({
  dealRollupData,
  groupingId,
  onDealCountClick = () => {},
  rowData
}) => {
  const {
    id,
    isUser,
    counts
  } = rowData;
  const value = dealRollupData.get(groupingId);
  const count = counts === null || counts === void 0 ? void 0 : counts[groupingId];
  return /*#__PURE__*/_jsx(RightAlignedTD, {
    "data-test-id": `row-cell-${groupingId}`,
    children: /*#__PURE__*/_jsxs(View, {
      paddingBlock: "200",
      children: [/*#__PURE__*/_jsx(StyledCurrencyWrapper, {
        children: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
          value: value.value,
          currencyCode: value.currencyCode
        })
      }), /*#__PURE__*/_jsx(DealCount, {
        count: count,
        groupingId: groupingId,
        ownerId: id,
        isUser: isUser,
        onDealCountClick: onDealCountClick
      })]
    })
  }, groupingId);
};
export default DealRollupCell;